import React, { useCallback, useEffect, useMemo, useState } from "react"
import { useParams } from "react-router-dom"
import { useApi } from "../../hooks/ApiProvider"
import { Col, Row } from "react-bootstrap"
import { MessageType, useMessageReport } from "../../components/MessageReporter"
import { PermissionSelector } from "../../components/Permissions/PermissionSelector"
import { useRole } from "../../components/RoleContext"

export const RoleDetail = () => {
    const { id } = useParams()
    const { managementApi } = useApi()
    const { addMessage } = useMessageReport()
    const { reloadMe, me } = useRole()

    const [role, setRole] = useState()
    const [permissions, setPermissions] = useState()
    const isDirty = useMemo(
        () => new Set(role?.permissions).symmetricDifference(new Set(permissions)).size !== 0,
        [role, permissions]
    )

    const loadRole = useCallback(
        () =>
            managementApi
                .managementGetRole({ roleId: id })
                .then((r) => {
                    setRole(r)
                    setPermissions(r.permissions)
                })
                .catch((e) => {
                    addMessage(
                        "Failed to get role",
                        "Something went wrong while getting the role, " +
                            "see the console for more details.",
                        MessageType.error,
                        e
                    )
                }),
        [managementApi, id, addMessage]
    )

    useEffect(() => {
        loadRole()
    }, [loadRole])

    const updateRole = useCallback(
        () =>
            managementApi
                .managementUpdateRole({
                    roleId: id,
                    permissions: {
                        permissions: permissions,
                    },
                })
                .then(loadRole)
                .then(() => me.roleProperties.id === id && reloadMe())
                .then(() =>
                    addMessage(
                        "Role updated",
                        "The role permissions have been updated successfully.",
                        MessageType.success
                    )
                )
                .catch((e) =>
                    addMessage(
                        "Failed to update role",
                        "Something went wrong while updating the role permissions, " +
                            "see the console for more details.",
                        MessageType.error,
                        e
                    )
                ),
        [managementApi, id, permissions, loadRole, me, reloadMe, addMessage]
    )

    return (
        <Row className="content-section">
            <Col>
                {!role ? (
                    <>
                        <h2>Role</h2>
                        <p>Loading...</p>
                    </>
                ) : (
                    <>
                        <h1>{role.name}</h1>
                        <h2>Permissions</h2>
                        <div className="mb-3">
                            <button
                                className="btn btn-primary"
                                onClick={updateRole}
                                disabled={!isDirty}
                            >
                                Save
                            </button>
                        </div>
                        <PermissionSelector
                            activePermissions={permissions}
                            setPermissions={setPermissions}
                        />
                    </>
                )}
            </Col>
        </Row>
    )
}
